import { useAxiosClient } from '../hooks';
import { createQueryKey } from '../utils';
import useMutation from './useMutation';
export default function useCreateOne(variant, basePath, options) {
  const axiosClient = useAxiosClient();
  async function mutationFn(data) {
    const url = variant.replace('{basePath}', basePath);
    const response = await axiosClient.post(url, data);
    return response.data;
  }
  const mutationKey = createQueryKey(basePath, variant);
  const mutation = useMutation(mutationKey, mutationFn, options);
  return mutation;
}